import { HStack, Text } from '@chakra-ui/react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, type AvailableIcons } from '$/components/common/Icon';
import { type FilterOptionGroup } from '$/services/usecases/filter';
import { useCollectionStore } from '$/stores/useCollectionStore';

interface Props {
  filterGroup: FilterOptionGroup;
  placeholder?: string;
  filterIcon?: AvailableIcons;
  onSingleFilterSelected: (filterSearchName: string) => void;
}

export const MobileFilterSingle: FC<Props> = ({
  filterGroup,
  filterIcon,
  onSingleFilterSelected,
}) => {
  const { t } = useTranslation();

  const appliedFilterOption = useCollectionStore
    .getState()
    .appliedFilterOptions.find(
      (filter) => filter.option === filterGroup.searchField,
    );

  const appliedFilter = filterGroup.items.find(
    (filter) => filter.value === appliedFilterOption?.value,
  );

  const getFilterPlaceholder = () => {
    switch (filterGroup.searchField) {
      case 'producer':
        return t('inspirationEditor.filter.producerDefault');
      case 'collection':
        return t('inspirationEditor.filter.collectionDefault');
      default:
        return undefined;
    }
  };

  return (
    <HStack
      justify='space-between'
      my='2'
      px='4'
      py='2'
      bg='background'
      border='1px solid'
      borderColor='border'
      borderRadius='8px'
      cursor='pointer'
      onClick={() => onSingleFilterSelected(filterGroup.searchField)}
    >
      <Text
        color={
          filterGroup.displayName
            ? 'textButton.color'
            : 'textButton.disabledColor'
        }
        fontSize='sm'
        fontWeight='bold'
      >
        {appliedFilter?.displayName ?? getFilterPlaceholder()}
      </Text>
      <Icon flex='flex-end' w='12px' icon={filterIcon ?? 'arrow_right'} />
    </HStack>
  );
};
